/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from "react-dom/client";
import Router from "./Router";
import posthog from "posthog-js";

posthog.init("phc_ccTcSrPxPH96PAGvcNKc9Mjmqv0lWAaYzYgiVijkCi5", {
  api_host: "https://app.posthog.com",
  capture_pageview: true,
});
import "./index.css";

function start() {
  const root = createRoot(document.getElementById("root")!);
  root.render(<Router />);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
